import React, { useRef } from 'react'
import { FaRegFileImage } from 'react-icons/fa'
import CustomButton from './CustomButton'
import { DeleteIcon } from '../utils/TableActionIcons'
import { useTranslation } from 'react-i18next'

const UploadExcelFile = ({ file, setFile, isLoading }) => {
  const { t } = useTranslation()
  const fileInputRef = useRef(null)

  const handleBrowseClick = () => {
    fileInputRef.current.click()
  }

  const handleFileChange = event => {
    const selectedFile = event.target.files[0]
    if (selectedFile) {
      const newFiles = selectedFile
      setFile(newFiles)
    }
  }

  const handleDrop = event => {
    event.preventDefault()
    const droppedFile = event.dataTransfer.files[0]
    if (droppedFile) {
      const newFile = droppedFile
      setFile(newFile)
    }
  }

  const handleRemoveFile = () => {
    if (isLoading) {
      return
    } else {
      setFile(null)
    }
  }

  return (
    <div className='p-4 border border-dashed border-gray-300 rounded-md hover:border-primary transition'>
      <div
        className='flex flex-col items-center'
        onDrop={handleDrop}
        onDragOver={event => event.preventDefault()}
      >
        <div className='w-fit bg-gray-100 p-3 rounded-full flex items-center justify-center'>
          <FaRegFileImage size={25} className='text-primary' />
        </div>
        <p className='text-16-gray'>{t('drag_and_drop_your_file_here')}</p>
        <div className='mt-3'>
          <input
            type='file'
            hidden
            ref={fileInputRef}
            accept='.xlsx'
            onChange={handleFileChange}
          />
          <CustomButton
            disabled={isLoading}
            label={t('browse_file')}
            icon='pi pi-upload'
            onClick={handleBrowseClick}
          />
        </div>
        {file && (
          <div className='border border-gray-300 mt-3 px-3 py-[5px] w-full rounded-md flex items-center justify-between'>
            <p className='text-14-gray'>{file.name}</p>
            <DeleteIcon onClick={handleRemoveFile} />
          </div>
        )}
      </div>
    </div>
  )
}

export default UploadExcelFile
